import React, { PropTypes } from 'react';
import Slider from 'react-slick';
import { v4 } from 'node-uuid';
import { Link } from 'react-router';
import partial from 'lodash/partial';
import merge from 'lodash/merge';
import classnames from 'classnames';
import ReviewsAgg from 'marketing/containers/reviews_agg';

const PrevButton = ({ onClick }) => (
  <i className="fa fa-angle-left btn-prev" onClick={onClick} />
);

const NextButton = ({ onClick }) => (
  <i className="fa fa-angle-right btn-next" onClick={onClick} />
);

PrevButton.propTypes = {
  onClick: PropTypes.func,
};

NextButton.propTypes = {
  onClick: PropTypes.func,
};

const SETTINGS = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <PrevButton />,
  nextArrow: <NextButton />
};

const Testimonials = ({  title, testimonials, showLink, background }) => (
  <section className={classnames("block block-testimonial", background)}>
    <div className="row columns">
      <div className="block-header">
        <ReviewsAgg title={<h2>{ title }</h2>} />
      </div>
    </div>
    <div className="row">
      <div className="small-16 medium-12 medium-offset-2 large-10 large-offset-3 columns">
        <Slider {...merge({}, SETTINGS, { nextArrow: <NextButton />, prevArrow: <PrevButton /> })}>
          {testimonials.map(({ headline, image, content_html, user, date }) => (
            <div className="testimonial" key={v4()}>
              <div className="quote">
                <h3>&quot;{headline}&quot;</h3>
                <p className="show-for-medium">
                  &quot;
                  <span dangerouslySetInnerHTML={{ __html: content_html }} />
                  &quot;
                </p>
              </div>
              <img alt={headline} src={image} className="avatar avatar-round avatar-testimonial" />
              <div className="testimonial-meta">
                <span>{user}</span>{date && <span>,{date}</span>}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  </section>
);

Testimonials.propTypes = {
  title: PropTypes.string,
  testimonials: PropTypes.array,
  showLink: PropTypes.bool,
  background: PropTypes.string,
};

export default Testimonials;
